import { Component, Input, OnDestroy, OnInit, PLATFORM_ID, Inject, ChangeDetectorRef, Optional } from '@angular/core';
import { KreuzfahrtFilters } from '../../../../models/filtermodels/KreuzfahrtFilters';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { CruiseFiltersService } from '@app/services/cruis/cruisefilters.service';
import { isPlatformBrowser } from '@angular/common';
import moment from 'moment';
import { CruiseService } from '@app/services/cruise.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { Partner } from '@app/models/partner/IPartner';
import { CruiseRegion } from '@app/models/kreuzfahrts/CruiseRegion';
import { CruiseCompany } from '@app/models/kreuzfahrts/CruiseCompany';
import { Schiffe } from '@app/models/kreuzfahrts/Schiffe';
import { MEDIA_TOKEN } from '../../../../../../tockens';
interface Item1 {
    land?: string;
    name: string;
    code: string;
    id: string;
    selected: boolean;
}
@Component({
    selector: 'app-cruisefilter',
    templateUrl: './cruisefilter.component.html',
    styleUrls: ['./cruisefilter.component.scss'],
    standalone: false
})
export class CruisefilterComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() realparams: KreuzfahrtFilters;
    @Input() reference: string;
    protected unsubscribe$ = new Subject();
    myKrzfilters: KreuzfahrtFilters = {} as KreuzfahrtFilters;
    media: string = 'xl';

    isBrowser: boolean = false;
    showMore: boolean = false;
    smallVersion: boolean = true;
    btntext: string = 'FERIEN SUCHEN';
    start: string;
    end: string;
    currentpartner: Partner;
    cruiseregions: CruiseRegion[] = [];
    cruiseCompany: CruiseCompany[] = [];
    cruiseCompanypriority: CruiseCompany[] = [];
    cruiseschiffe: Schiffe[] = [];

    airports: Item1[] = [];
    startHafenDatas: Item1[] = [];
    ziehlHafenDatas: Item1[] = [];

    constructor(
        protected dialog: MatDialog,
        protected cruiseService: CruiseService,
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected cruiseFiltersService: CruiseFiltersService,
        protected guardService: AuthGuardService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.initMedia();
        this.initPartner();
        if (this.isBrowser) {
            this.setFilters();
        }
    }

    setFilters(): void {
        if (this.realparams) {
            this.realparams.productType = 'kreuzfahrt';
            this.cruiseFiltersService.onlySetRealParams(this.realparams);
        } else if (this.mode === 'home') {
            this.cruiseFiltersService.resetAllExtrasHome();
        }
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((partner) => {
            if (partner?.partnerid?.length > 0) {
                this.currentpartner = partner;
                this.getFilters();
            }
        });
    }

    async getPorts() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruiseregionsdsi').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(res => {
            this.initPorts(res);
        });
    }

    async getAirPorts() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruiseairports').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(res => {
            this.initAirports(res);
        });
    }

    async initMedia() {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    async getCruiseRegionen() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruiseregions').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data?.length > 0) {
                if (this.myKrzfilters?.cruiseregion?.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < this.myKrzfilters.cruiseregion.length; j++) {
                            if (data[i].id === this.myKrzfilters.cruiseregion[j].id) {
                                data[i].selected = true;
                            }
                        }
                    }
                }
                this.cruiseregions = this.cleanDoublon(data);
                this.cdr.detectChanges();
            }
        });
    }

    cleanDoublon(data): any[] {
        for (let i = 0; i < data.length; i++) {
            for (let j = i + 1; j < data.length; j++) {
                if (data[i].id === data[j].id) {
                    data.splice(j, 1);
                    j--;
                }
            }
        }

        return data;
    }

    async getCruiseCompany() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruisecompanys').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data?.length > 0) {
                if (this.myKrzfilters?.cruisecompanys?.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < this.myKrzfilters.cruisecompanys.length; j++) {
                            if (data[i].id === this.myKrzfilters.cruisecompanys[j].id) {
                                data[i].selected = true;
                            }
                        }
                    }
                }
                this.cruiseCompany = this.cleanDoublon(data);
                this.cruiseCompanypriority = [];
                for (let i = 0; i < this.cruiseCompany.length; i++) {
                    if (
                        this.cruiseCompany[i].vc === 'TUIC' ||
                        this.cruiseCompany[i].vc === 'AQVH' ||
                        this.cruiseCompany[i].vc === 'CARN' ||
                        this.cruiseCompany[i].vc === 'CEL' ||
                        this.cruiseCompany[i].vc === 'CELES' ||
                        this.cruiseCompany[i].vc === 'COLOR' ||
                        this.cruiseCompany[i].vc === 'CST' ||
                        this.cruiseCompany[i].vc === 'CUNARD' ||
                        this.cruiseCompany[i].vc === 'EMERALD' ||
                        this.cruiseCompany[i].vc === 'EXPLORA' ||
                        this.cruiseCompany[i].vc === 'HANSA' ||
                        this.cruiseCompany[i].vc === 'HLKF' ||
                        this.cruiseCompany[i].vc === 'HAL' ||
                        this.cruiseCompany[i].vc === 'MSC' ||
                        this.cruiseCompany[i].vc === 'NICH' ||
                        this.cruiseCompany[i].vc === 'NCL' ||
                        this.cruiseCompany[i].vc === 'OCE' ||
                        this.cruiseCompany[i].vc === 'POC' ||
                        this.cruiseCompany[i].vc === 'PHX' ||
                        this.cruiseCompany[i].vc === 'PLAN' ||
                        this.cruiseCompany[i].vc === 'PONANT' ||
                        this.cruiseCompany[i].vc === 'PC' ||
                        this.cruiseCompany[i].vc === 'RSS' ||
                        this.cruiseCompany[i].vc === 'RCCL' ||
                        this.cruiseCompany[i].vc === 'ROW' ||
                        this.cruiseCompany[i].vc === 'RVS' ||
                        this.cruiseCompany[i].vc === 'SCENIC' ||
                        this.cruiseCompany[i].vc === 'SEAB' ||
                        this.cruiseCompany[i].vc === 'SEAC' ||
                        this.cruiseCompany[i].vc === 'SEAD' ||
                        this.cruiseCompany[i].vc === 'SILV' ||
                        this.cruiseCompany[i].vc === 'STARCL' ||
                        this.cruiseCompany[i].vc === 'SWAN' ||
                        this.cruiseCompany[i].vc === 'TRDW' ||
                        this.cruiseCompany[i].vc === 'AZA'
                    ) {
                        this.cruiseCompanypriority.push(this.cruiseCompany[i]);
                    }
                }
                this.cdr.detectChanges();
            }
        });
    }

    async getCruiseSchifes() {
        this.cruiseService.request({ ref: this.currentpartner?.xt?.ref }, 'cruiseschiffe').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data?.length > 0) {
                if (this.myKrzfilters?.schiffes?.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        for (let j = 0; j < this.myKrzfilters.schiffes.length; j++) {
                            if (data[i].id === this.myKrzfilters.schiffes[j].id) {
                                data[i].selected = true;
                            }
                        }
                    }
                }
                this.cruiseschiffe = this.cleanDoublon(data);
                this.cdr.detectChanges();
            }
        });
    }

    async initAirports(res) {
        if (res?.length > 0) {
            for (let i = 0; i < res.length; i++) {
                let selected = false;
                if (this.myKrzfilters?.airports?.length > 0) {
                    for (let j = 0; j < this.myKrzfilters.airports.length; j++) {
                        if (res[i].code === this.myKrzfilters.airports[j].code) {
                            selected = true;
                            j = this.myKrzfilters.airports.length;
                        }
                    }
                }
                this.airports.push({
                    id: res[i].code,
                    code: res[i].code,
                    name: res[i].name,
                    land: res[i].land,
                    selected: selected
                });
            }
            this.cdr.detectChanges();
            this.airports = JSON.parse(JSON.stringify(this.airports));
        }
    }

    async initPorts(res) {
        if (res?.length > 0) {
            for (let i = 0; i < res.length; i++) {
                let selected = false;
                if (this.myKrzfilters?.cruisestarthafen?.length > 0) {
                    for (let j = 0; j < this.myKrzfilters.cruisestarthafen.length; j++) {
                        if (res[i].code === this.myKrzfilters.cruisestarthafen[j].code) {
                            selected = true;
                            j = this.myKrzfilters.cruisestarthafen.length;
                        }
                    }
                }
                this.startHafenDatas.push({
                    id: res[i].code,
                    code: res[i].code,
                    name: res[i].name,
                    land: res[i].land,
                    selected: selected
                });
                let selected1 = false;
                if (this.myKrzfilters?.cruisezielhafen?.length > 0) {
                    for (let j = 0; j < this.myKrzfilters.cruisezielhafen.length; j++) {
                        if (res[i].code === this.myKrzfilters.cruisezielhafen[j].code) {
                            selected1 = true;
                            j = this.myKrzfilters.cruisezielhafen.length;
                        }
                    }
                }
                this.ziehlHafenDatas.push({
                    id: res[i].code,
                    code: res[i].code,
                    land: res[i].land,
                    name: res[i].name,
                    selected: selected1
                });
            }
            this.cdr.detectChanges();
            this.startHafenDatas = JSON.parse(JSON.stringify(this.startHafenDatas));
            this.ziehlHafenDatas = JSON.parse(JSON.stringify(this.ziehlHafenDatas));
        }
    }

    async getFilters() {
        this.cruiseFiltersService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(params => {
            if (params) {
                this.myKrzfilters = JSON.parse(JSON.stringify(params));
                this.initDate(this.myKrzfilters);
                if (this.startHafenDatas?.length === 0 || this.ziehlHafenDatas?.length === 0) {
                    this.getPorts();
                } else {
                    this.checkPort();
                }
                if (this.airports?.length === 0) {
                    this.getAirPorts();
                } else {
                    this.checkAirports();
                }
                if (this.cruiseregions?.length === 0) {
                    this.getCruiseRegionen();
                } else {
                    this.checkRegion();
                }
                if (this.cruiseCompany?.length === 0) {
                    this.getCruiseCompany();
                } else {
                    this.checkCompany();
                }
                if (this.cruiseschiffe?.length === 0) {
                    this.getCruiseSchifes();
                } else {
                    this.checkSchifes();
                }
            }
        });
    }

    async checkSchifes() {
        if (this.myKrzfilters?.schiffes?.length > 0) {
            for (let i = 0; i < this.cruiseschiffe.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.schiffes.length; j++) {
                    if (this.cruiseschiffe[i].id === this.myKrzfilters.schiffes[j].id) {
                        selected = true;
                        j = this.myKrzfilters.schiffes.length;
                    }
                }
                this.cruiseschiffe[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.cruiseschiffe.length; i++) {
                this.cruiseschiffe[i].selected = false;
            }
        }

        this.cruiseschiffe = JSON.parse(JSON.stringify(this.cruiseschiffe));
    }

    async checkCompany() {
        if (this.myKrzfilters?.cruisecompanys?.length > 0) {
            for (let i = 0; i < this.cruiseCompany.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.cruisecompanys.length; j++) {
                    if (this.cruiseCompany[i].id === this.myKrzfilters.cruisecompanys[j].id) {
                        selected = true;
                        j = this.myKrzfilters.cruisecompanys.length;
                    }
                }
                this.cruiseCompany[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.cruiseCompany.length; i++) {
                this.cruiseCompany[i].selected = false;
            }
        }

        this.cruiseCompany = JSON.parse(JSON.stringify(this.cruiseCompany));
    }

    async checkRegion() {
        if (this.myKrzfilters?.cruiseregion?.length > 0) {
            for (let i = 0; i < this.cruiseregions.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.cruiseregion.length; j++) {
                    if (this.cruiseregions[i].id === this.myKrzfilters.cruiseregion[j].id) {
                        selected = true;
                        j = this.myKrzfilters.cruiseregion.length;
                    }
                }
                this.cruiseregions[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.cruiseregions.length; i++) {
                this.cruiseregions[i].selected = false;
            }
        }

        this.cruiseregions = JSON.parse(JSON.stringify(this.cruiseregions));
    }

    async checkAirports() {
        if (this.myKrzfilters?.airports?.length > 0) {
            for (let i = 0; i < this.airports.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.airports.length; j++) {
                    if (this.airports[i].id === this.myKrzfilters.airports[j].id || this.airports[i].code === this.myKrzfilters.airports[j].code) {
                        selected = true;
                        j = this.myKrzfilters.airports.length;
                    }
                }
                this.airports[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.airports.length; i++) {
                this.airports[i].selected = false;
            }
        }

        this.airports = JSON.parse(JSON.stringify(this.airports));
    }

    async checkPort() {
        if (this.myKrzfilters?.cruisestarthafen?.length > 0) {
            for (let i = 0; i < this.startHafenDatas.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.cruisestarthafen.length; j++) {
                    if (this.startHafenDatas[i].id === this.myKrzfilters.cruisestarthafen[j].id || this.startHafenDatas[i].code === this.myKrzfilters.cruisestarthafen[j].code) {
                        selected = true;
                        j = this.myKrzfilters.cruisestarthafen.length;
                    }
                }
                this.startHafenDatas[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.startHafenDatas.length; i++) {
                this.startHafenDatas[i].selected = false;
            }
        }
        // zielhafen
        if (this.myKrzfilters?.cruisezielhafen?.length > 0) {
            for (let i = 0; i < this.ziehlHafenDatas.length; i++) {
                let selected = false;
                for (let j = 0; j < this.myKrzfilters.cruisezielhafen.length; j++) {
                    if (this.ziehlHafenDatas[i].id === this.myKrzfilters.cruisezielhafen[j].id || this.ziehlHafenDatas[i].code === this.myKrzfilters.cruisezielhafen[j].code) {
                        selected = true;
                        j = this.myKrzfilters.cruisezielhafen.length;
                    }
                }
                this.ziehlHafenDatas[i].selected = selected;
            }
        } else {
            for (let i = 0; i < this.ziehlHafenDatas.length; i++) {
                this.ziehlHafenDatas[i].selected = false;
            }
        }

        this.startHafenDatas = JSON.parse(JSON.stringify(this.startHafenDatas));
        this.ziehlHafenDatas = JSON.parse(JSON.stringify(this.ziehlHafenDatas));
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    gotoZiel(): void {
        this.smallVersion = true;
        this.cruiseFiltersService.setReference(this.reference);
        this.cruiseFiltersService.gotourl();
    }

    initDate(filter): void {
        const reg = new RegExp('^\\d+,\\d+,\\d+$');
        if (String(filter?.reisezeitraumResult).match(reg)) {
            const tmp = String(filter?.reisezeitraumResult).split(',');
            this.start = moment().add(tmp[0], 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(tmp[1]) + Number(tmp[0]), 'days').format('YYYY-MM-DD');
        } else if (filter?.reisezeitraumResult?.start?.length > 0) {
            if (moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
                this.start = moment().add(4, 'days').format('DD.MM.YYYY');
                this.end = moment().add(180, 'days').format('DD.MM.YYYY');
            } else {
                this.start = moment(filter.reisezeitraumResult.start).format('YYYY-MM-DD');
                this.end = moment(filter.reisezeitraumResult.end).format('YYYY-MM-DD');
            }
        } else if (!isNaN(Number(filter.reisezeitraumResult?.start))) {
            this.start = moment().add(Number(filter.reisezeitraumResult.start), 'days').format('YYYY-MM-DD');
            this.end = moment().add(Number(filter.reisezeitraumResult.end), 'days').format('YYYY-MM-DD');
        } else {
            this.start = moment().add(4, 'days').format('YYYY-MM-DD');
            this.end = moment().add(180, 'days').format('YYYY-MM-DD');
        }
    }

    selectDateValue(ev): void {
        this.cruiseFiltersService.reisezeitraumResult(ev.start, ev.end);
    }

    openclosemore(): void {
        this.showMore = !this.showMore;
        if (!this.showMore) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    async resTraveler(ev) {
        this.cruiseFiltersService.reisendeResult(ev);
    }

    setRes(filed, ev) {
        this.myKrzfilters[filed] = ev;
        switch (filed) {
            case 'cruiseregion':
                this.cruiseFiltersService.cruiseregion(ev);
                break;
            case 'cruisecompanys':
                this.cruiseFiltersService.cruisecompanys(ev);
                break;
            case 'cruisestarthafen':
                this.cruiseFiltersService.cruisestarthafen(ev);
                break;
            case 'cruisezielhafen':
                this.cruiseFiltersService.cruisezielhafen(ev);
                break;
            case 'airports':
                this.cruiseFiltersService.airports(ev);
                break;

            default:
                this.cruiseFiltersService.schiffes(ev);
                break;
        }
    }

    showMBMenu(): void {
        this.smallVersion = false;
    }
}
